import axios from "../axios-auth";

export const cashNoteService = {
    getCashNoteList,
    saveCashNote,
    getCashNoteDetail,
    getCashNoteByStatus
};

function getCashNoteList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.name) {
        params["name"] = searchParams.name;
    }

    if (searchParams.currencyCode) {
        params["currencyCode"] = searchParams.currencyCode;
    }

    if (searchParams.status) {
        params["status"] = searchParams.status;
    }

    return axios.get("/auth/cash-notes", { params });
}

function saveCashNote(cashNote) {
    if (!cashNote.id) {
        // new cash note
        return axios.post("/auth/cash-note", cashNote);
    } else {
        // edit
        return axios.put("/auth/cash-note", cashNote);
    }
}

function getCashNoteDetail(id) {
    return axios.get("/auth/cash-note/" + id);
}

function getCashNoteByStatus(status) {
    return axios.get('auth/cash-note-by-status/' + status);
}